export default {
    stickers: {
        title: 'Stickers',
        stickerOpacity: 'Sticker opacity',
        stickerColor: 'Sticker Color',
        shapes: {
            title: 'Shapes',
            rectangle: 'Rectangle',
            circle: 'Circle',
            triangle: 'Triangle',
        },
        emojis: {
            title: 'Emojis',
        },
    },
};
